import { useMemo } from 'react'

import { usePageInfo } from 'providers/PageInfoProvider'

import {
  selectCurrentVariantCohortToUse,
  selectCurrentVariantSteps,
} from 'root-redux/selects/common'
import { selectUserStatus } from 'root-redux/selects/user'

import { useBulkSelector } from 'hooks/common/useBulkSelector'
import { useUpsellStatus } from 'hooks/user/useUpsellStatus'

import { PageId } from 'root-constants/pages'

const useSelectors = () =>
  useBulkSelector({
    steps: selectCurrentVariantSteps,
    userStatus: selectUserStatus,
    cohortToUse: selectCurrentVariantCohortToUse,
  })

export const useUserStatus = (): string => {
  const { steps, userStatus } = useSelectors()

  const { currentSubscriptionPageId, currentUpsellPageId } = usePageInfo()
  const isUpsellAvailable = useUpsellStatus()

  return useMemo(() => {
    if (userStatus?.account.hasAccount) {
      return PageId.DOWNLOAD
    }

    if (isUpsellAvailable) {
      return currentUpsellPageId
    }

    if (userStatus?.hasSubscription) {
      return PageId.ACCOUNT
    }

    if (userStatus?.email.hasEmail) {
      return currentSubscriptionPageId || steps[0].id
    }

    return ''
  }, [
    currentSubscriptionPageId,
    currentUpsellPageId,
    isUpsellAvailable,
    steps,
    userStatus,
  ])
}
